import { Box, Button } from '@mantine/core';
import { ChevronRight } from 'lucide-react';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';
import { useStepperOnboarding } from '@/stepper/context/StepperOnboardingContext';
import { CLASS_NAMES } from '../../classNames';

const StepperSetupCompleteActions: FC = () => {
	const { localization } = useHostContext();
	const { finishOnboarding } = useStepperOnboarding();
	return (
		<Box className={CLASS_NAMES.setupCompleteActions}>
			<Button
				className={CLASS_NAMES.setupPrimaryAction}
				classNames={{
					section: 'ml-0'
				}}
				data-testid="stepper-setup-complete-agent-configuration-button"
				onClick={finishOnboarding}
				rightSection={
					<ChevronRight
						aria-hidden="true"
						className="h-4 w-4"
					/>
				}
				type="button"
			>
				<span className="leading-normal">
					{localization.translate(
						'creator',
						'stepperOnboarding.setupComplete.activation.keepCustomizing'
					)}
				</span>
			</Button>
		</Box>
	);
};

export default StepperSetupCompleteActions;
